import React from 'react';
import HeadToHeadRecords from './HeadToHeadRecords';

/**
 * Head-to-Head tab content for Player Dashboard
 */
const PlayerHeadToHeadTab = ({ 
  currentPlayerId,
  selectedClub,
  selectedSeason,
  initialOpponentId = null,
}) => {
  return (
    <div className="space-y-8">
      <HeadToHeadRecords 
        currentPlayerId={currentPlayerId}
        selectedClub={selectedClub}
        selectedSeason={selectedSeason}
        initialOpponentId={initialOpponentId}
      />
    </div>
  );
};

export default PlayerHeadToHeadTab;
